import { memo } from 'react';
import { Badge } from '@bbpos/ui';
import { LEDGER_TYPE_BADGE } from './status';
import type { LedgerEntryType } from './types';

export const LedgerTypeBadge = memo(function LedgerTypeBadge({
  type,
}: {
  type: LedgerEntryType;
}) {
  const meta = LEDGER_TYPE_BADGE[type] ?? LEDGER_TYPE_BADGE.CREDIT_SALE;
  return (
    <Badge variant={meta.variant} size="sm">
      {meta.label}
    </Badge>
  );
});
